import request from '@/utils/request'

export function updateWildCfg(data) {
  return request({
    url: 'api/v1/wild/updateWildCfg',
    method: 'post',
    data: data
  })
}

export function getWildCfgList(data) {
  return request({
    url: 'api/v1/wild/getList',
    method: 'post',
    data: data
  })
}

export function getFirstCfg(data) {
  return request({
    url: 'api/v1/wild/getFirst',
    method: 'post',
    data: data
  })
}

export function delFirstCfg(data) {
  return request({
    url: 'api/v1/wild/delFirst',
    method: 'delete',
    data: data
  })
}

export function getSmallGameType() {
  return request({
    url: 'api/v1/wild/getSmallGameType',
    method: 'get'
  })
}

